import React from 'react';
import { useIntl } from 'umi';
import { SelectMultiple, SelectMultipleProps, Tooltip } from 'tea-component';
import {
  ACCUMULATED_DEFAULT_VALUE,
  GROUP_BY_INDEX,
  SEPARATED_OPTIONS,
} from '@/pages/dashboard/components/Accumulate/constant';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import classNames from 'classnames';
import { IAccumulateProps } from '@/pages/dashboard/components/Accumulate/type';

function Accumulate(props: IAccumulateProps) {
  const {
    value = [],
    onChange = () => { },
    selectOptions = [],
    accumulateSelectMultipleBoxClassName,
    ...otherProps
  } = props || {};
  const selectValue = JSON.parse(JSON.stringify(value));
  // selectValue?.length === 0 && selectValue?.unshift('time');

  const { formatMessage } = useIntl();
  const { getLocalText } = useLocal();
  const GROUPS = {
    separated: formatMessage({ id: 'common_Separated' }),
  };

  const ACCUMULATED_OPTIONS = [
    {
      value: ACCUMULATED_DEFAULT_VALUE,
      text: formatMessage({ id: 'common_Accumulated' }),
    },
  ];

  return (
    <SelectMultiple
      key="Overall_Performance_Sel"
      // className="table-line-select"
      boxClassName={classNames("table-line-select-box", accumulateSelectMultipleBoxClassName)}
      appearance="button"
      style={{ width: 230 }}
      listHeight={232}
      matchButtonWidth
      // groups={GROUPS}
      options={selectOptions}
      value={selectValue}
      staging={false}
      onChange={(newValue, context) => {
        if (
          newValue.length > 0 &&
          newValue[newValue.length - 1] === ACCUMULATED_DEFAULT_VALUE
        ) {
          onChange([ACCUMULATED_DEFAULT_VALUE], context);
        } else {
          const values = newValue.filter(
            (i) => i !== ACCUMULATED_DEFAULT_VALUE,
          );
          values.sort((a, b) => GROUP_BY_INDEX[a] - GROUP_BY_INDEX[b]);
          onChange(values, context);
        }
      }}
      button={(options) => (
        <div className="table-line-select-value">
          <span className="dimension">{getLocalText('common_Dimension')}</span>
          {options?.length === 0 ? formatMessage({ id: 'common_Accumulated' }) : options?.map((o) => o?.text)?.join(', ')}
        </div>
      )}
      {...otherProps}
    />
  );
}

export interface AccumulateProps extends SelectMultipleProps { }

export { ACCUMULATED_DEFAULT_VALUE, SEPARATED_OPTIONS };
export default Accumulate;
